export const isNonContainedContainableCall = (call: { isContainable: boolean; isContained: boolean }): boolean =>
    call.isContainable === true && call.isContained !== true;
